import config from "config";
import { getAuthToken } from "lib/providers";

/**
 * Direct GraphQL fetch using the correct access token.
 * Used for custom queries/mutations not available in @scrile/api-provider.
 */
export default async function gqlFetch(query: string, variables: Record<string, any> = {}): Promise<any> {
  const token = await getAuthToken();
  const resp = await fetch(config.apiUrl, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: token } : {}),
    },
    body: JSON.stringify({ query, variables }),
  });
  return resp.json();
}
